import React from 'react'

interface UploadProgressBarProps {
  readonly percentage: number
}

const UploadProgressBar: React.FC<UploadProgressBarProps> = (props) => {
  const { percentage } = props

  const getProgressBarWidthClass = (percentageToShow: number) => {
    const clamped = Math.min(100, Math.max(0, Math.round(percentageToShow)))
    return `QuickStart__progress-bar-fill-w${clamped}`
  }

  const fillClassName = `QuickStart__progress-bar-fill ${getProgressBarWidthClass(percentage)}`

  return (
    <div className="QuickStart__progress-bar-container">
      <div className={fillClassName} />
    </div>
  )
}

export default UploadProgressBar
